import React from 'react'
import { isCustomDomain } from 'src/shared/utils/is-custom-domain'

export interface WebsitePublicLogoProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  logoUrl?: string
  isHeader?: boolean
  isCustomDomain?: boolean
}

export const WebsitePublicLogo: React.FC<WebsitePublicLogoProps> = ({
  logoUrl,
  style,
  isHeader = false,
  isCustomDomain: isCustomDomainProp,
  ...rest
}) => {
  const isCustomDomainValue = isCustomDomainProp ?? isCustomDomain()
  const sioLogoUrlSmall = `${process.env.CLOUDFRONT_PUBLISHER_ASSETS_HOST}/assets/images/logo.png`
  const sioLogoUrlLarge = `${process.env.CLOUDFRONT_PUBLISHER_ASSETS_HOST}/assets/images/sio_logo.svg`
  const baseStyle: React.CSSProperties = {
    display: 'block',
    margin: '0 auto',
    marginBottom: isHeader ? '0' : '12px',
  }

  if (!isCustomDomainValue) {
    return (
      <img
        src={isHeader ? sioLogoUrlLarge : sioLogoUrlSmall}
        alt="Logo"
        style={{
          ...baseStyle,
          maxWidth: isHeader ? '137px' : '52px',
          ...style,
        }}
        {...rest}
      />
    )
  }

  return logoUrl ? (
    <img
      src={logoUrl}
      alt="Logo"
      style={{
        maxHeight: '50px',
        objectFit: 'contain',
        width: 'auto',
        ...baseStyle,
        ...style,
      }}
      {...rest}
    />
  ) : null
}
